/* Reconnect safely when Shopify's theme editor reloads a section. */
(() => {
  function mount(root = document) {
    const sections = root.matches?.('[data-es-carousel]') ? [root] : root.querySelectorAll('[data-es-carousel]');
    sections.forEach(section => {
      if (section.dataset.esMounted) return;
      const track = section.querySelector('.es-track');
      const previous = section.querySelector('[data-es-prev]');
      const next = section.querySelector('[data-es-next]');
      if (!track || !previous || !next) return;
      section.dataset.esMounted = 'true';
      const update = () => {
        const left = Math.abs(track.scrollLeft);
        previous.disabled = left < 2;
        next.disabled = left + track.clientWidth >= track.scrollWidth - 2;
      };
      const advance = direction => {
        const rtl = getComputedStyle(track).direction === 'rtl';
        track.scrollBy({ left: direction * (rtl ? -1 : 1) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => advance(-1));
      next.addEventListener('click', () => advance(1));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      } else window.addEventListener('resize', update, { passive: true });
      update();
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
